module.exports = __webpack_public_path__ + "media/images/pokerroom/titan/step3-full-e098d5871f8d12e635a4f104d2c9184c.jpg";